<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      fanhuiIcon: `${this.$cdnLink}/wanXin/orangeTheme/back1.png`,
    }
  }
};
</script>

<style lang="scss" module>
@import '../../assets/css/redEnvelope.scss';

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: normal;
    }
    .fanhui {
      position: absolute;
      top: -0.15rem;
      right: 0.8rem;
      width: 0.7rem;
      height: 0.7rem;
    }
  }
  > main {
    padding: 0.15rem 0.2rem;
    overflow-y: auto;
    .antiIndulged {
      .content {
        > p {
          padding: 0 .25rem .15rem 0.55rem;
          font-size: 0.24rem;
          color: #404040;
        }
      }
      .bindFm {
        width: 4.44rem;
        height: 0.68rem;
        background: #f7f7f7;
        border-radius: 0.1rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0.15rem auto;
        > img {
          margin-left: .06rem;
          width: .26rem;
        }
        > input {
          width: 3.8rem;
          margin: 0 0.1rem;
          background: none;
          border: none;
        }
      }
      .btnGp {
        display: flex;
        justify-content: center;
        margin-top: 0.15rem;
        > button {
          @include common-button();
          width: 2rem;
          height: 0.58rem;
          margin: 0 0.2rem;
        }
      }
      .antiInduledHint {
        color: #888888;
        font-size: 0.2rem;
        line-height: 0.26rem;
        padding: 0 .45rem .15rem 0.55rem;
        text-align: left;
        margin-top: 0.1rem;
        > button {
          background: none;
          border: none;
          outline: none;
          color: $primary-color;
          font-size: 0.2rem;
        }
        > a {
          color: $primary-color;
        }
      }
      .antiInduledCp {
        position: absolute;
        left: 0;
        top: -1000rem;
        z-index: -1;
      }
    }
  }
  // 全屏版本
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 17px 5px;
      overflow-y: auto;
      .antiIndulged {
        .content {
          min-height: 100px;
        }
        p {
          padding: 0 0 0 7px;
          font-size: 12px;
        }
        .bindFm {
          width: 222px;
          height: 34px;
          background: #f7f7f7;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 7px auto;
          > img {
            width: 13px;
            margin-left: 3px;
          }
          > input {
            width: 190px;
            margin: 0 5px;
            background: none;
            border: none;
          }
        }
        .btnGp {
          display: flex;
          justify-content: center;
          margin-top: 7px;
          > button {
            @include full-screen-button();
            width: 100px;
            height: 29px;
            margin: 0 10px;
          }
        }
        .antiInduledHint {
          color: #888888;
          font-size: 10px;
          line-height: 13px;
          text-align: center;
          margin-top: 10px;
          > a {
            background: none;
            border: none;
            outline: none;
            color: $primary-color;
            font-size: 10px;
          }
          > span {
            color: $primary-color;
          }
        }
        .antiInduledCp {
          position: absolute;
          left: 0;
          top: -1000px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
,
